/*
  Accelerated Aesthetics cart goal bar
  Shows how far a cart is from the automatic 15% off at $250 subtotal.
  Added 2026-11-02. To remove: delete this file and its script tag in layout/theme.liquid.
*/
(function () {
  'use strict';

  var THRESHOLD = 25000;        // cents, matches the automatic discount minimum subtotal
  var PERCENT = 15;
  var NS = 'aa-cart-goal';
  var busy = false;
  var timer = null;

  var CSS =
    '.' + NS + '{margin:0 0 16px;padding:13px 15px;border:1px solid #dbe5ea;background:#f7fafb;' +
    'border-radius:3px;font-size:13px;line-height:1.45;color:#334641;letter-spacing:.01em;text-align:left;}' +
    '.' + NS + '__text{margin:0 0 9px;font-size:13px;line-height:1.45;text-align:left;}' +
    '.' + NS + '__text strong{font-weight:600;}' +
    '.' + NS + '__track{height:4px;border-radius:3px;background:#e4ecef;overflow:hidden;}' +
    '.' + NS + '__fill{display:block;height:100%;background:#aebec6;border-radius:3px;' +
    'transition:width .35s ease;}' +
    '.' + NS + '--hit{background:#f4f8f5;border-color:#cfe2d6;}' +
    '.' + NS + '--hit .' + NS + '__fill{background:#7fa68f;}';

  function css() {
    if (document.getElementById(NS + '-css')) return;
    var s = document.createElement('style');
    s.id = NS + '-css';
    s.appendChild(document.createTextNode(CSS));
    (document.head || document.documentElement).appendChild(s);
  }

  function money(cents) {
    var v = cents / 100;
    var whole = v % 1 === 0;
    try {
      return '$' + v.toLocaleString('en-US', {
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2
      });
    } catch (e) {
      return '$' + (whole ? String(v) : v.toFixed(2));
    }
  }

  function hosts() {
    var out = [];
    var drawer = document.querySelector('#drawer-cart .drawer__body');
    if (drawer) out.push(drawer);
    var page = document.querySelector('.cart__template .cart__footer__total');
    if (page) out.push(page);
    return out;
  }

  function render(subtotal) {
    css();
    hosts().forEach(function (host) {
      var el = host.querySelector('.' + NS);
      if (el && el.parentNode !== host) el = null;

      if (!subtotal || subtotal <= 0) {
        if (el) el.parentNode.removeChild(el);
        return;
      }
      if (!el) {
        el = document.createElement('div');
        el.className = NS;
        host.insertBefore(el, host.firstChild);
      }

      var left = THRESHOLD - subtotal;
      var pct = Math.max(3, Math.round((subtotal / THRESHOLD) * 100));
      pct = left > 0 ? Math.min(99, pct) : 100;
      var text;

      if (left > 0) {
        el.className = NS;
        text = 'You are <strong>' + money(left) + '</strong> away from ' + PERCENT + '% off your order.';
      } else {
        el.className = NS + ' ' + NS + '--hit';
        text = '<strong>' + PERCENT + '% off unlocked.</strong> It comes off automatically at checkout.';
      }

      var html =
        '<p class="' + NS + '__text">' + text + '</p>' +
        '<span class="' + NS + '__track"><span class="' + NS + '__fill" style="width:' + pct + '%"></span></span>';

      if (el.innerHTML !== html) el.innerHTML = html;
    });
  }

  function subtotalOf(cart) {
    if (!cart) return 0;
    return typeof cart.items_subtotal_price === 'number' ? cart.items_subtotal_price : (cart.total_price || 0);
  }

  function cartUrl() {
    var base = (window.theme && window.theme.routes && window.theme.routes.cart) || '/cart';
    return base + '.js';
  }

  function update() {
    if (busy) return;
    busy = true;
    window.fetch(cartUrl(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(subtotalOf(c)); })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(update, 200);
  }

  // The theme broadcasts the cart on every ajax change.
  document.addEventListener('theme:cart:change', function (e) {
    if (e && e.detail && e.detail.cart) { render(subtotalOf(e.detail.cart)); } else { schedule(); }
  });

  // Catch cart writes the theme makes without broadcasting.
  function isCartWrite(url) {
    if (!url) return false;
    url = String(url);
    return url.indexOf('/cart/') !== -1 && url.indexOf('cart.js') === -1;
  }

  if (window.fetch) {
    var nf = window.fetch;
    window.fetch = function () {
      var u = '';
      try { u = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || ''; } catch (err) {}
      var p = nf.apply(this, arguments);
      if (isCartWrite(u) && p && p.then) { p.then(schedule, function () {}); }
      return p;
    };
  }

  var xo = XMLHttpRequest.prototype.open;
  var xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__aaUrl = u; return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var self = this;
    this.addEventListener('load', function () { if (isCartWrite(self.__aaUrl)) schedule(); });
    return xs.apply(this, arguments);
  };

  // Re-insert if the theme re-renders the drawer or the cart footer.
  function observe() {
    if (!window.MutationObserver || !document.body) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (!t || !t.closest) continue;
        if (t.closest('.' + NS)) continue;
        if (t.closest('#drawer-cart') || t.closest('.cart__template')) { schedule(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() { css(); update(); observe(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
